import { SeriesReportTable } from './SeriesReportTable';

export default SeriesReportTable;
